import { MsalProvider } from '@azure/msal-react';

import Providers from '@m/providers';
import { msalInstance } from '@m/utils/msalConfig';

import Admin from './Admin';
import { AdminAppBox } from './AdminApp.styled';

export default function App() {
  return (
    <Providers>
      <MsalProvider instance={msalInstance}>
        <AdminAppBox>
          <Admin />
        </AdminAppBox>
      </MsalProvider>
    </Providers>
  );
}
